var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { UPDATE_SORT_RAITING } from '../actions/sortRaitingAction';
var initialState = {
    sorting: null
};
export function sortRaitingReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_SORT_RAITING:
            return __assign(__assign({}, state), { sorting: action.payload });
        default:
            return state;
    }
}
;
export function getSorting(state) {
    return state.rSorting || '';
}
//# sourceMappingURL=sortRaiting.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { UPDATE_SORT_RAITING } from '../actions/sortRaitingAction';
var initialState = {
    sorting: null
};
export function sortRaitingReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_SORT_RAITING:
            return __assign(__assign({}, state), { sorting: action.payload });
        default:
            return state;
    }
}
;
export function getSorting(state) {
    return state.rSorting || '';
}
//# sourceMappingURL=sortRaiting.js.map